import { Component,EventEmitter,Input,Output } from '@angular/core';
import { MatChip,MatChipListbox,MatChipOption } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import {
CorrespondenceFilterViewModel as CorFilter,
CorFilterType,
CorrespondenceSubFilterViewModel as CorSubFilter,
} from '../../../view-models/filters';

@Component({
  selector: 'app-filter-viewer',
  imports: [MatChip, MatChipListbox, MatIconModule, MatChipOption],
  templateUrl: './filter-viewer.component.html',
  styleUrls: ['./filter-viewer.component.css'],
  standalone: true,
})
export class FilterViewerComponent {
  @Input() filter: CorFilter;
  @Output() updated: EventEmitter<CorFilter> = new EventEmitter<CorFilter>();

  filterTypes: typeof CorFilterType = CorFilterType;
  constructor() {}


  removeFilter(f: CorSubFilter) {
    const i = this.filter.Filters.indexOf(f);
    if (i >= 0) {
      this.filter.Filters.splice(i, 1);
    }
    this.updated.emit(this.filter);
  }

  switchSorting() {
    this.filter.Ascending = !this.filter.Ascending;
    this.updated.emit(this.filter);
  }
}
